import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../../utils/useWindowDimensions';

const UsersStatGraph = ({ chartAnalytics }) => {
  let {width , height} = useWindowDimensions();

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'bar',
      width: '100%',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [],
      tickAmount: 15,
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    colors: ["#CA353B", "#333333"],
  });

  const [chartSeries, setChartSeries] = useState([
    {
      name: 'Active Users',
      data: [],
    },
    {
      name: 'Inactive Users',
      data: [],
    },
  ]);


  useEffect(()=>{

      setChartSeries([
        {
          name: 'Active Users',
          data: chartAnalytics?.users?.chart?.map(e => e.counts.active) || [],
        },
        {
          name: 'Inactive Users',
          data: chartAnalytics?.users?.chart?.map(e => e.counts.inactive) || [],
        },
      ]);

      setChartOptions({
        chart: {
          type: 'bar',
          width: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: chartAnalytics?.users?.chart?.map(e => e.label)|| [],
          tickAmount: 15,
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        colors: ["#CA353B", "#333333"],
      });

  },[chartAnalytics])


  return (
    <div id="chart">
      <ReactApexChart 
      options={chartOptions} 
      series={chartSeries} 
      type="bar" 
      height={width > 1400 && width < 1650 ? 270 : width > 1650 ? 320 : 235}/>
    </div>
  );
};

export default UsersStatGraph;
